/* document.querySelectorAll(".gla-marquee-content").forEach((marquee) => {
	const firstSet = marquee.querySelector(".gla-marquee-set");
	if (firstSet) {
		const clone = firstSet.cloneNode(true);
		clone.setAttribute("aria-hidden", "true");
		marquee.appendChild(clone);
	}
}); */

/* ungerade pixelwerte verursachen eventuell ein ruckeln im marquee (=> ceil) */
document.querySelectorAll(".gla-marquee-content").forEach((marquee) => {
	const firstSet = marquee.querySelector(".gla-marquee-set");

	if (firstSet) {
		// 1. Die exakte Breite messen und aufrunden
		// getBoundingClientRect() ist genauer als offsetWidth
		const exactWidth = firstSet.getBoundingClientRect().width;
		const roundedWidth = Math.ceil(exactWidth);

		// 2. Die abgerundete Breite fest auf das erste Set schreiben
		firstSet.style.width = `${roundedWidth}px`;
		firstSet.style.flex = "0 0 auto"; // Sicherstellen, dass Flexbox die Breite respektiert

		// 3. Erst jetzt klonen
		const clone = firstSet.cloneNode(true);
		clone.setAttribute("aria-hidden", "true");

		// 4. Den Klon anhängen
		marquee.appendChild(clone);
	}
});
